<template>
  <div>
    <div class="card p-4 shadow-sm">
      <h3 class="mb-3">Mesas</h3>

      <!-- Botón agregar -->
      <div class="d-flex justify-content-end gap-2 mb-3">
        <button
          class="btn btn-outline-secondary"
          :disabled="cargandoQrTodas"
          @click="abrirModalQrTodas"
        >
          {{ cargandoQrTodas ? "Generando..." : "Imprimir todos los QR" }}
        </button>
        <button class="btn btn-outline-primary" @click="abrirModalPlano">
          Editor visual
        </button>
        <button class="btn btn-success" @click="abrirModalCrear">
          + Agregar Mesa
        </button>
      </div>

      <!-- Toast -->
      <div
        v-if="mostrarToast"
        class="toast-container position-fixed top-0 end-0 p-3"
        style="z-index: 1055"
      >
        <div class="toast show align-items-center text-white" :class="toastColor">
          <div class="d-flex">
            <div class="toast-body">
              <i :class="iconoToast" class="me-2"></i>
              {{ alerta.mensaje }}
            </div>
            <button
              type="button"
              class="btn-close btn-close-white me-2 m-auto"
              @click="cerrarToast"
            ></button>
          </div>
        </div>
      </div>

      <!-- Tabla -->
      <div class="table-responsive">
        <table class="table table-bordered text-center align-middle">
          <thead class="table-light">
            <tr>
              <th>Número Mesa</th>
              <th>Estado</th>
              <th>Fila</th>
              <th>Columna</th>
              <th>Orden</th>
              <th>Distribución</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="mesas.length === 0">
              <td colspan="7">No hay mesas registradas.</td>
            </tr>
            <tr v-for="mesa in mesas" :key="mesa.IdMesa">
              <td>{{ mesa.Numero }}</td>
              <td>
                <span
                  :class="{
                    'badge bg-success': mesa.Estado === 0,
                    'badge bg-warning text-dark': mesa.Estado === 1,
                    'badge bg-danger': mesa.Estado === 2
                  }"
                >
                  {{ estadoNombre(mesa.Estado) }}
                </span>
              </td>
              <td>
                <input
                  v-model.number="mesa.FilaPlano"
                  type="number"
                  min="1"
                  class="form-control form-control-sm"
                  placeholder="-"
                />
              </td>
              <td>
                <input
                  v-model.number="mesa.ColumnaPlano"
                  type="number"
                  min="1"
                  class="form-control form-control-sm"
                  placeholder="-"
                />
              </td>
              <td>
                <input
                  v-model.number="mesa.OrdenPlano"
                  type="number"
                  min="1"
                  class="form-control form-control-sm"
                  placeholder="-"
                />
              </td>
              <td>
                <button
                  class="btn btn-outline-secondary btn-sm"
                  @click="guardarDistribucion(mesa)"
                >
                  Guardar
                </button>
              </td>
              <td>
                <button
                  class="btn btn-outline-secondary btn-sm me-2"
                  @click="abrirModalQr(mesa)"
                >
                  Ver QR
                </button>
                <button
                  class="btn btn-primary btn-sm me-2"
                  @click="abrirModalEditar(mesa)"
                >
                  Editar
                </button>
                <button
                  class="btn btn-danger btn-sm"
                  @click="abrirModalEliminar(mesa)"
                >
                  Eliminar
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Modal Crear -->
    <div v-if="mostrarModalCrear" class="modal-backdrop">
      <div class="modal-content">
        <h5>Nueva Mesa</h5>
        <input
          v-model="nuevaMesa.Numero"
          type="text"
          class="form-control mt-3"
          placeholder="Número de mesa"
        />
        <div class="text-end mt-3">
          <button class="btn btn-secondary me-2" @click="cerrarModalCrear">
            Cancelar
          </button>
          <button class="btn btn-primary" @click="guardarMesa">
            Guardar
          </button>
        </div>
      </div>
    </div>

    <!-- Modal Editar -->
    <div v-if="mostrarModalEditar" class="modal-backdrop">
      <div class="modal-content">
        <h5>Editar Mesa</h5>
        <input
          v-model="mesaEditar.Numero"
          type="text"
          class="form-control mt-3"
          placeholder="Número de la mesa"
        />
        <label class="form-label mt-3">Estado</label>
        <select v-model.number="mesaEditar.Estado" class="form-select">
          <option :value="0" v-if="mesaEditar.Estado !== 1">Libre</option>
          <option :value="2" v-if="mesaEditar.Estado !== 1">Fuera de servicio</option>
          <option :value="1" v-if="mesaEditar.Estado === 1" disabled>Ocupada</option>
        </select>
        <div class="row mt-3 g-2">
          <div class="col-4">
            <label class="form-label">Fila</label>
            <input
              v-model.number="mesaEditar.FilaPlano"
              type="number"
              min="1"
              class="form-control"
              placeholder="Ej: 1"
            />
          </div>
          <div class="col-4">
            <label class="form-label">Columna</label>
            <input
              v-model.number="mesaEditar.ColumnaPlano"
              type="number"
              min="1"
              class="form-control"
              placeholder="Ej: 1"
            />
          </div>
          <div class="col-4">
            <label class="form-label">Orden</label>
            <input
              v-model.number="mesaEditar.OrdenPlano"
              type="number"
              min="1"
              class="form-control"
              placeholder="Ej: 10"
            />
          </div>
        </div>
        <small class="text-muted d-block mt-2">
          Si dejas fila o columna vacía, esa mesa no tendrá posición fija en el plano.
        </small>
        <div class="text-end mt-3">
          <button class="btn btn-secondary me-2" @click="cerrarModalEditar">
            Cancelar
          </button>
          <button class="btn btn-primary" @click="actualizarMesa">
            Guardar
          </button>
        </div>
      </div>
    </div>

    <!-- Modal Eliminar -->
    <div v-if="mostrarModalEliminar" class="modal-backdrop">
      <div class="modal-content">
        <h5>Confirmar eliminación</h5>
        <p>
          ¿Seguro que deseas eliminar la mesa
          <strong>{{ mesaEliminar?.Numero }}</strong>?
        </p>
        <div class="text-end mt-3">
          <button class="btn btn-secondary me-2" @click="cerrarModalEliminar">
            Cancelar
          </button>
          <button class="btn btn-danger" @click="eliminarMesa">
            Eliminar
          </button>
        </div>
      </div>
    </div>

    <!-- Modal Plano Visual -->
    <div v-if="mostrarModalPlano" class="modal-backdrop">
      <div class="modal-content modal-plano-content">
        <div class="d-flex justify-content-between align-items-center">
          <h5 class="mb-0">Editor visual de mesas</h5>
          <button class="btn btn-sm btn-outline-secondary" @click="cerrarModalPlano">
            Cerrar
          </button>
        </div>

        <div class="row g-2 mt-2">
          <div class="col-6 col-md-3">
            <label class="form-label">Columnas</label>
            <input
              v-model.number="columnasPlano"
              type="number"
              min="2"
              max="12"
              class="form-control"
            />
          </div>
          <div class="col-6 col-md-3">
            <label class="form-label">Filas</label>
            <input
              v-model.number="filasPlano"
              type="number"
              min="1"
              max="20"
              class="form-control"
            />
          </div>
          <div class="col-12 col-md-6 d-flex align-items-end">
            <small class="text-muted">
              Arrastra una mesa y suéltala en la celda deseada. Si hay una mesa en esa celda, se intercambian.
            </small>
          </div>
        </div>

        <div class="plano-layout mt-3">
          <div>
            <h6>Mesas sin ubicar</h6>
            <div class="panel-sin-ubicar">
              <div
                v-for="mesa in mesasSinPosicionEditable"
                :key="`pool-${mesa.IdMesa}`"
                class="mesa-draggable"
                :class="estadoClaseTarjeta(mesa.Estado)"
                draggable="true"
                @dragstart="iniciarArrastreMesa(mesa)"
              >
                Mesa {{ mesa.Numero }}
              </div>
              <small v-if="!mesasSinPosicionEditable.length" class="text-muted">
                Todas las mesas están ubicadas.
              </small>
            </div>
          </div>

          <div>
            <h6>Plano</h6>
            <div class="plano-grid" :style="estiloGridPlano">
              <div
                v-for="celda in celdasPlano"
                :key="`celda-${celda.fila}-${celda.columna}`"
                class="celda-plano"
                @dragover.prevent
                @drop="soltarEnCelda(celda.fila, celda.columna)"
              >
                <div class="celda-label">F{{ celda.fila }} C{{ celda.columna }}</div>
                <div
                  v-if="celda.mesa"
                  class="mesa-draggable mesa-en-celda"
                  :class="estadoClaseTarjeta(celda.mesa.Estado)"
                  draggable="true"
                  @dragstart="iniciarArrastreMesa(celda.mesa)"
                  @dblclick="quitarMesaDelPlano(celda.mesa)"
                >
                  Mesa {{ celda.mesa.Numero }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="text-end mt-3">
          <button class="btn btn-secondary me-2" @click="cerrarModalPlano">
            Cancelar
          </button>
          <button class="btn btn-primary" :disabled="guardandoPlano" @click="guardarPlanoVisual">
            {{ guardandoPlano ? "Guardando..." : "Guardar distribución" }}
          </button>
        </div>
      </div>
    </div>

    <!-- Modal QR individual -->
    <div v-if="mostrarModalQr" class="modal-backdrop">
      <div class="modal-content text-center">
        <h5>QR Mesa {{ qrMesa?.mesa }}</h5>
        <div v-if="cargandoQr" class="py-4">
          <div class="spinner-border text-primary" role="status"></div>
        </div>
        <template v-else-if="qrMesa">
          <img :src="qrMesa.qr_png" alt="QR mesa" class="img-fluid my-3" />
          <p class="text-muted small text-break">{{ qrMesa.url }}</p>
        </template>
        <div class="text-end mt-3">
          <button class="btn btn-secondary me-2" @click="cerrarModalQr">
            Cerrar
          </button>
          <button
            class="btn btn-primary"
            :disabled="cargandoQr || !qrMesa"
            @click="imprimirQrs([qrMesa])"
          >
            Imprimir
          </button>
        </div>
      </div>
    </div>

    <!-- Modal QR de todas las mesas -->
    <div v-if="mostrarModalQrTodas" class="modal-backdrop">
      <div class="modal-content text-center" style="width: 500px">
        <h5>QR de todas las mesas</h5>
        <div v-if="cargandoQrTodas" class="py-4">
          <div class="spinner-border text-primary" role="status"></div>
        </div>
        <p v-else class="text-muted small">
          Se generaron {{ qrTodas.length }} códigos QR. Usa "Imprimir" para
          imprimirlos todos de una vez.
        </p>
        <div class="text-end mt-3">
          <button class="btn btn-secondary me-2" @click="cerrarModalQrTodas">
            Cerrar
          </button>
          <button
            class="btn btn-primary"
            :disabled="cargandoQrTodas || !qrTodas.length"
            @click="imprimirQrs(qrTodas)"
          >
            Imprimir todos
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { API_URL } from "@/config/config.js";

export default {
  name: "MesasRestaurante",
  data() {
    return {
      mesas: [],
      mostrarModalCrear: false,
      mostrarModalEditar: false,
      mostrarModalEliminar: false,
      mostrarModalPlano: false,
      nuevaMesa: { Numero: "" },
      mesaEditar: null,
      mesaEliminar: null,
      mostrarToast: false,
      alerta: { mensaje: "", tipo: "success" },
      columnasPlano: 5,
      filasPlano: 4,
      mesasPlanoEditable: [],
      mesaArrastrandoId: null,
      guardandoPlano: false,
      mostrarModalQr: false,
      cargandoQr: false,
      qrMesa: null,
      mostrarModalQrTodas: false,
      cargandoQrTodas: false,
      qrTodas: [],
    };
  },
  computed: {
    toastColor() {
      return this.alerta.tipo === "success" ? "bg-success" : "bg-danger";
    },
    iconoToast() {
      return this.alerta.tipo === "success"
        ? "bi bi-check-circle"
        : "bi bi-exclamation-circle";
    },
    mesasSinPosicionEditable() {
      return this.mesasPlanoEditable.filter((mesa) => {
        return this.normalizarNumeroPlano(mesa.FilaPlano) === null || this.normalizarNumeroPlano(mesa.ColumnaPlano) === null;
      });
    },
    estiloGridPlano() {
      return {
        gridTemplateColumns: `repeat(${this.columnasPlano}, minmax(110px, 1fr))`,
      };
    },
    celdasPlano() {
      const celdas = [];
      for (let fila = 1; fila <= this.filasPlano; fila += 1) {
        for (let columna = 1; columna <= this.columnasPlano; columna += 1) {
          celdas.push({
            fila,
            columna,
            mesa: this.mesaEnCelda(fila, columna),
          });
        }
      }
      return celdas;
    },
  },
  methods: {
    estadoNombre(estado) {
      switch (estado) {
        case 0:
          return "Libre";
        case 1:
          return "Ocupada";
        case 2:
          return "Fuera de servicio";
        default:
          return "Desconocido";
      }
    },
    cerrarToast() {
      this.mostrarToast = false;
    },
    mostrarAlerta(mensaje, tipo = "success") {
      this.alerta = { mensaje, tipo };
      this.mostrarToast = true;
      setTimeout(this.cerrarToast, 3000);
    },
    async obtenerMesas() {
      const { data } = await axios.get(`${API_URL}/mesas`);
      this.mesas = data;
    },
    abrirModalCrear() {
      this.nuevaMesa = { Numero: "" };
      this.mostrarModalCrear = true;
    },
    cerrarModalCrear() {
      this.mostrarModalCrear = false;
    },
    async guardarMesa() {
      try {
        await axios.post(`${API_URL}/mesas`, this.nuevaMesa);
        this.mostrarAlerta("Mesa creada correctamente");
        this.cerrarModalCrear();
        this.obtenerMesas();
      } catch (error) {
        this.mostrarAlerta(
          error.response?.data?.message || "Error al crear",
          "danger"
        );
      }
    },
    estadoClaseTarjeta(estado) {
      switch (estado) {
        case 0:
          return "mesa-draggable-libre";
        case 1:
          return "mesa-draggable-ocupada";
        case 2:
          return "mesa-draggable-fuera";
        default:
          return "";
      }
    },
    abrirModalPlano() {
      this.mesasPlanoEditable = this.mesas.map((mesa) => ({
        ...mesa,
        FilaPlano: this.normalizarNumeroPlano(mesa.FilaPlano),
        ColumnaPlano: this.normalizarNumeroPlano(mesa.ColumnaPlano),
        OrdenPlano: this.normalizarNumeroPlano(mesa.OrdenPlano),
      }));

      const maxColumna = Math.max(
        ...this.mesasPlanoEditable
          .map((mesa) => this.normalizarNumeroPlano(mesa.ColumnaPlano) || 0),
        5
      );
      const maxFila = Math.max(
        ...this.mesasPlanoEditable
          .map((mesa) => this.normalizarNumeroPlano(mesa.FilaPlano) || 0),
        Math.ceil(Math.max(this.mesas.length, 1) / maxColumna),
        4
      );

      this.columnasPlano = maxColumna;
      this.filasPlano = maxFila;
      this.mesaArrastrandoId = null;
      this.mostrarModalPlano = true;
    },
    cerrarModalPlano() {
      this.mostrarModalPlano = false;
      this.mesaArrastrandoId = null;
      this.guardandoPlano = false;
    },
    iniciarArrastreMesa(mesa) {
      this.mesaArrastrandoId = mesa.IdMesa;
    },
    mesaEnCelda(fila, columna) {
      return this.mesasPlanoEditable.find((mesa) => {
        return this.normalizarNumeroPlano(mesa.FilaPlano) === fila && this.normalizarNumeroPlano(mesa.ColumnaPlano) === columna;
      }) || null;
    },
    soltarEnCelda(fila, columna) {
      if (!this.mesaArrastrandoId) {
        return;
      }

      const mesaArrastrada = this.mesasPlanoEditable.find((mesa) => mesa.IdMesa === this.mesaArrastrandoId);
      if (!mesaArrastrada) {
        return;
      }

      const filaOrigen = this.normalizarNumeroPlano(mesaArrastrada.FilaPlano);
      const columnaOrigen = this.normalizarNumeroPlano(mesaArrastrada.ColumnaPlano);

      const mesaOcupante = this.mesasPlanoEditable.find((mesa) => {
        return mesa.IdMesa !== mesaArrastrada.IdMesa
          && this.normalizarNumeroPlano(mesa.FilaPlano) === fila
          && this.normalizarNumeroPlano(mesa.ColumnaPlano) === columna;
      });

      mesaArrastrada.FilaPlano = fila;
      mesaArrastrada.ColumnaPlano = columna;

      if (mesaOcupante) {
        mesaOcupante.FilaPlano = filaOrigen;
        mesaOcupante.ColumnaPlano = columnaOrigen;
      }

      this.mesaArrastrandoId = null;
    },
    quitarMesaDelPlano(mesa) {
      mesa.FilaPlano = null;
      mesa.ColumnaPlano = null;
      this.mesaArrastrandoId = null;
    },
    async guardarPlanoVisual() {
      this.guardandoPlano = true;

      const mesasConPosicion = this.mesasPlanoEditable
        .filter((mesa) => this.normalizarNumeroPlano(mesa.FilaPlano) && this.normalizarNumeroPlano(mesa.ColumnaPlano))
        .sort((a, b) => {
          const filaA = this.normalizarNumeroPlano(a.FilaPlano) || 999;
          const filaB = this.normalizarNumeroPlano(b.FilaPlano) || 999;
          if (filaA !== filaB) {
            return filaA - filaB;
          }

          const columnaA = this.normalizarNumeroPlano(a.ColumnaPlano) || 999;
          const columnaB = this.normalizarNumeroPlano(b.ColumnaPlano) || 999;
          if (columnaA !== columnaB) {
            return columnaA - columnaB;
          }

          return String(a.Numero).localeCompare(String(b.Numero), "es", {
            numeric: true,
            sensitivity: "base",
          });
        });

      const mesasSinPosicion = this.mesasPlanoEditable
        .filter((mesa) => !this.normalizarNumeroPlano(mesa.FilaPlano) || !this.normalizarNumeroPlano(mesa.ColumnaPlano))
        .sort((a, b) => String(a.Numero).localeCompare(String(b.Numero), "es", { numeric: true, sensitivity: "base" }));

      const ordenadas = [...mesasConPosicion, ...mesasSinPosicion];

      try {
        await Promise.all(
          ordenadas.map((mesa, index) => {
            const payload = {
              Numero: mesa.Numero,
              Estado: mesa.Estado,
              FilaPlano: this.normalizarNumeroPlano(mesa.FilaPlano),
              ColumnaPlano: this.normalizarNumeroPlano(mesa.ColumnaPlano),
              OrdenPlano: index + 1,
            };

            return axios.put(`${API_URL}/mesas/${mesa.IdMesa}`, payload);
          })
        );

        this.mostrarAlerta("Distribución visual guardada correctamente");
        this.cerrarModalPlano();
        await this.obtenerMesas();
      } catch (error) {
        this.mostrarAlerta(
          error.response?.data?.message || "Error al guardar distribución visual",
          "danger"
        );
      } finally {
        this.guardandoPlano = false;
      }
    },
    abrirModalEditar(mesa) {
      this.mesaEditar = {
        ...mesa,
        FilaPlano: this.normalizarNumeroPlano(mesa.FilaPlano),
        ColumnaPlano: this.normalizarNumeroPlano(mesa.ColumnaPlano),
        OrdenPlano: this.normalizarNumeroPlano(mesa.OrdenPlano),
      };
      this.mostrarModalEditar = true;
    },
    cerrarModalEditar() {
      this.mesaEditar = null;
      this.mostrarModalEditar = false;
    },
    async actualizarMesa() {
      const mesaOriginal = this.mesas.find(m => m.IdMesa === this.mesaEditar.IdMesa);
      if (mesaOriginal && mesaOriginal.Estado === 1 && mesaOriginal.Estado !== this.mesaEditar.Estado) {
        this.mostrarAlerta("No se puede cambiar el estado de una mesa ocupada", "danger");
        return;
      }

      const payload = {
        ...this.mesaEditar,
        FilaPlano: this.normalizarNumeroPlano(this.mesaEditar.FilaPlano),
        ColumnaPlano: this.normalizarNumeroPlano(this.mesaEditar.ColumnaPlano),
        OrdenPlano: this.normalizarNumeroPlano(this.mesaEditar.OrdenPlano),
      };

      try {
        await axios.put(
          `${API_URL}/mesas/${this.mesaEditar.IdMesa}`,
          payload
        );
        this.mostrarAlerta("Mesa actualizada correctamente");
        this.cerrarModalEditar();
        this.obtenerMesas();
      } catch (error) {
        this.mostrarAlerta(
          error.response?.data?.message || "Error al actualizar",
          "danger"
        );
      }
    },
    abrirModalEliminar(mesa) {
      this.mesaEliminar = mesa;
      this.mostrarModalEliminar = true;
    },
    cerrarModalEliminar() {
      this.mesaEliminar = null;
      this.mostrarModalEliminar = false;
    },
    async eliminarMesa() {
      try {
        await axios.delete(`${API_URL}/mesas/${this.mesaEliminar.IdMesa}`);
        this.mostrarAlerta("Mesa eliminada correctamente");
        this.obtenerMesas();
      } catch (error) {
        this.mostrarAlerta(
          error.response?.data?.message || "Error al eliminar",
          "danger"
        );
      } finally {
        this.cerrarModalEliminar();
      }
    },
    async abrirModalQr(mesa) {
      this.mostrarModalQr = true;
      this.cargandoQr = true;
      this.qrMesa = null;
      try {
        const { data } = await axios.get(`${API_URL}/mesas/${mesa.IdMesa}/qr`);
        this.qrMesa = data.data;
      } catch (error) {
        this.mostrarAlerta(
          error.response?.data?.message || "Error al generar el QR",
          "danger"
        );
        this.mostrarModalQr = false;
      } finally {
        this.cargandoQr = false;
      }
    },
    cerrarModalQr() {
      this.mostrarModalQr = false;
      this.qrMesa = null;
    },
    async abrirModalQrTodas() {
      this.mostrarModalQrTodas = true;
      this.cargandoQrTodas = true;
      this.qrTodas = [];
      try {
        const { data } = await axios.get(`${API_URL}/mesas/qr/todas`);
        this.qrTodas = data.data;
      } catch (error) {
        this.mostrarAlerta(
          error.response?.data?.message || "Error al generar los QR",
          "danger"
        );
        this.mostrarModalQrTodas = false;
      } finally {
        this.cargandoQrTodas = false;
      }
    },
    cerrarModalQrTodas() {
      this.mostrarModalQrTodas = false;
      this.qrTodas = [];
    },
    imprimirQrs(qrs) {
      const items = (qrs || []).filter(Boolean);
      if (!items.length) {
        return;
      }

      const ventana = window.open("", "_blank");
      if (!ventana) {
        return;
      }

      const contenido = items
        .map(
          (qr) => `
            <div class="qr-pagina">
              <h3>Mesa ${qr.mesa}</h3>
              <img src="${qr.qr_png}" alt="QR Mesa ${qr.mesa}" />
            </div>
          `
        )
        .join("");

      ventana.document.write(`
        <html>
          <head>
            <title>QR Mesas</title>
            <style>
              body { font-family: sans-serif; text-align: center; }
              .qr-pagina { page-break-after: always; padding-top: 40px; }
              .qr-pagina img { width: 280px; height: 280px; }
            </style>
          </head>
          <body>${contenido}</body>
        </html>
      `);
      ventana.document.close();

      // Esperar a que TODAS las imágenes (data URIs base64) terminen de
      // decodificar ANTES de imprimir. Si se llama print() de inmediato, el
      // diálogo de impresión captura las imágenes aún vacías → QR en blanco.
      let impreso = false;
      const lanzar = () => {
        if (impreso) return;
        impreso = true;
        ventana.focus();
        ventana.print();
      };

      const imagenes = Array.from(ventana.document.images);
      if (!imagenes.length) {
        lanzar();
      } else {
        let restantes = imagenes.length;
        const listo = () => {
          restantes -= 1;
          if (restantes <= 0) lanzar();
        };
        imagenes.forEach((img) => {
          if (img.complete) {
            listo();
          } else {
            img.addEventListener("load", listo);
            img.addEventListener("error", listo);
          }
        });
      }

      // Respaldo por si alguna imagen se cuelga: imprimir de todas formas.
      setTimeout(lanzar, 3000);
    },
    normalizarNumeroPlano(valor) {
      const numero = Number(valor);
      if (!Number.isInteger(numero) || numero < 1) {
        return null;
      }
      return numero;
    },
    async guardarDistribucion(mesa) {
      const payload = {
        Numero: mesa.Numero,
        Estado: mesa.Estado,
        FilaPlano: this.normalizarNumeroPlano(mesa.FilaPlano),
        ColumnaPlano: this.normalizarNumeroPlano(mesa.ColumnaPlano),
        OrdenPlano: this.normalizarNumeroPlano(mesa.OrdenPlano),
      };

      try {
        await axios.put(`${API_URL}/mesas/${mesa.IdMesa}`, payload);
        this.mostrarAlerta(`Distribución de mesa ${mesa.Numero} guardada`);
      } catch (error) {
        this.mostrarAlerta(
          error.response?.data?.message || "Error al guardar distribución",
          "danger"
        );
      }
    },
  },
  mounted() {
    this.obtenerMesas();
  },
};
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 5000;
}
.modal-content {
  background: #fff;
  width: 400px;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  z-index: 5001;
}

.modal-plano-content {
  width: min(1100px, 95vw);
  max-height: 92vh;
  overflow-y: auto;
}

.plano-layout {
  display: grid;
  grid-template-columns: 260px 1fr;
  gap: 16px;
}

.panel-sin-ubicar {
  min-height: 220px;
  border: 1px dashed #cbd5e1;
  border-radius: 10px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  background: #f8fafc;
}

.plano-grid {
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 10px;
  display: grid;
  gap: 8px;
  background: #f8fafc;
}

.celda-plano {
  min-height: 82px;
  border: 1px dashed #cbd5e1;
  border-radius: 8px;
  padding: 6px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 4px;
  background: #ffffff;
}

.celda-label {
  font-size: 11px;
  color: #64748b;
  text-align: center;
}

.mesa-draggable {
  text-align: center;
  border-radius: 8px;
  padding: 8px;
  font-weight: 600;
  cursor: grab;
  user-select: none;
}

.mesa-en-celda {
  margin-top: 2px;
}

.mesa-draggable-libre {
  background: #dcfce7;
  color: #166534;
}

.mesa-draggable-ocupada {
  background: #fef3c7;
  color: #92400e;
}

.mesa-draggable-fuera {
  background: #fee2e2;
  color: #991b1b;
}

@media (max-width: 992px) {
  .plano-layout {
    grid-template-columns: 1fr;
  }
}
</style>
